import * as Yup from "yup";

export type employeeDesigFilter = {
  searchName: string;
};

export const employeeDesigInitialValues: employeeDesigFilter = {
  searchName: "",
};

export const employeeDesigProperties = [
  {
    id: "searchName",
    type: "text",
    label: "Name",
    Placeholder: "Enter Designation Name",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: false,
  },
];

export const employeeDesigValidationSchema = Yup.object().shape({
  searchName: Yup.string().required("Name is required"),
});

export function hasAtLeastOneValue(obj: any, keys: string[]) {
  return keys.some((key) => {
    const value = obj[key];
    return (
      value !== "" &&
      value !== null &&
      value !== undefined &&
      !(Array.isArray(value) && value.length === 0) &&
      !(Array.isArray(value) && value.every(v => v === null))
    );
  });
}
